module.exports = "/_next/static/images/f9327e88b41be1a3403d4299a4ec88f7-savings-waitlist-promise-1a-lg-2x.jpg.webp";